export const ENV = {
  CONTENTSTACK_API_KEY: process.env.REACT_APP_CONTENTSTACK_API_KEY,
  CONTENTSTACK_DELIVERY_TOKEN: process.env.REACT_APP_CONTENTSTACK_DELIVERY_TOKEN,
  CONTENTSTACK_ENVIRONMENT: process.env.REACT_APP_CONTENTSTACK_ENVIRONMENT,
  CLICKSTREAM_API_BASE_URL: process.env.REACT_APP_CLICKSTREAM_API_BASE_URL,
  BUILD_VERSION: process.env.REACT_APP_BUILD_VERSION,
  GTM_ID: process.env.REACT_APP_GTM_ID
};
